import { Flags } from "src/consts/flags";

export const flagDefaults: Record<Flags, boolean | object | number> = {
  [Flags.PLANNED_MAINTENANCE]: {},
  [Flags.SCHEDULED_MAINTENANCE]: {},
  [Flags.CHALLENGE_JOURNEY]: import.meta.env.VITE_ACCEPT_CHALLENGE_JOURNEY_ENABLED,
  [Flags.BANK_DETAILS_JOURNEY]: import.meta.env.VITE_BANK_DETAILS_ENABLED
};
